import { Crisp } from 'crisp-sdk-web'

// after load page and its images and content
window.addEventListener('load', () => {
  Crisp.configure('09a603bb-0882-4dcf-88c0-fcc9e505f740', {
    sessionMerge: true,
    safeMode: true,
  })
})
